var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('AddTodo',{on:{"add-item":_vm.addItem}}),_c('TodoList',{attrs:{"todos":_vm.todos},on:{"delete-item":_vm.deleteItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }